import React from "react";
import cx from "classnames";

interface IAFCannotContinueProps {
    reason?: string[];
}

const AFCannotContinue: React.FC<IAFCannotContinueProps> = (props) => {
    const { reason } = props;
    const closePage = () => {
        window.close();
    };

    return (
        <div className={cx("panel-appform-message")}>
            <h2>Sorry</h2>
            <p>We are unable to continue your application. Our team will be in touch soon to discuss your options.</p>
            {reason.map((r) => {
                return (<p>{r}</p>);
            })}
            <button
                type="button"
                className={cx("btn-primary")}
                onClick={closePage}>
            Close
            </button>
        </div>
    );
};

export default AFCannotContinue;